import { render, staticRenderFns } from "./unload-content-header.vue?vue&type=template&id=1c065304"
import script from "./unload-content-header.vue?vue&type=script&lang=js"
export * from "./unload-content-header.vue?vue&type=script&lang=js"
import style0 from "./unload-content-header.vue?vue&type=style&index=0&id=1c065304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports